// Global Instructions Rule Applied!

import React from 'react'
import { Card, Statistic } from 'antd'
import type { CSSProperties } from 'react'

interface KpiTileProps {
  title: string
  /**
   * Pre-formatted display string. Source of truth for formatting is the SQL
   * `format_values()` helper, so the value already includes currency symbols,
   * decimals, percent signs, etc. Statistic renders the string verbatim.
   */
  value: string | number | null | undefined
  loading?: boolean
  valueStyle?: CSSProperties
  /** Optional subtle helper text under the value (e.g. "vs. invested"). */
  helper?: string
}

/**
 * KpiTile — Card + AntD Statistic. Standard KPI cell used on summary
 * dashboards (Fund Dashboard, future module dashboards). Pairs with
 * <FormSection> for the surrounding section header.
 */
export function KpiTile({ title, value, loading = false, valueStyle, helper }: KpiTileProps): React.ReactElement {
  const displayValue = value === null || value === undefined || value === '' ? '–' : value
  return (
    <Card size='small' className='shadow-sm border border-gray-200' loading={loading}>
      <Statistic title={title} value={displayValue as string | number} valueStyle={valueStyle} />
      {helper && <div className='text-xs text-gray-500 mt-1'>{helper}</div>}
    </Card>
  )
}

export default KpiTile
